import {ResidentStatus} from '@/services/graphqlHooks';

export const getResidentStatusClasses = (status: ResidentStatus) => {
  switch (status) {
    case ResidentStatus.Pending:
      return 'bg-blue-200 border-blue-200 text-blue-700';
    case ResidentStatus.Active:
      return 'bg-accent-200 border-accent-200 text-primary-900';
    case ResidentStatus.Absent:
      return 'bg-purple-light border-purple-light text-purple-900';
    case ResidentStatus.Deactivated:
      return 'bg-red-100 border-red-100 text-red-700';
    default:
      return 'bg-neutral-100 border-neutral-100 text-neutral-900';
  }
};

export const getFileSizeInHumanReadableFormat = (fileSize: number): string => {
  if (fileSize < 100000) {
    return `${Math.round(fileSize / 1000)} kB`;
  } else if (fileSize < 1000000000) {
    return `${Math.round(fileSize / 1000000)} MB`;
  } else {
    return `${Math.round(fileSize / 1000000000)} GB`;
  }
};
